// removed by extract-text-webpack-plugin
module.exports = {"container":"RepairFacilityDetails-hashed__container__FtJwP","detail":"RepairFacilityDetails-hashed__detail__WOAKr","primaryDetail":"RepairFacilityDetails-hashed__primaryDetail__20dIr","secondaryDetail":"RepairFacilityDetails-hashed__secondaryDetail__18eCB","repairButton":"RepairFacilityDetails-hashed__repairButton__1I609"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilityDetails/RepairFacilityDetails-hashed.scss
// module id = 1174
// module chunks = 0